import { createSlice } from '@reduxjs/toolkit';

export const navSlice = createSlice({
	name: 'nav',
	initialState: {
		variant: 'transparent',
		size: null,
		open: false,
	},
	reducers: {
		setTransparent: (state) => {
			state.variant = 'transparent';
		},
		setOpaque: (state) => {
			state.variant = 'opaque';
		},
		setSmoke: (state) => {
			state.variant = 'smoke';
		},
		setOpen: (state, action) => {
			state.open = action.payload;
		},
		setSize: (state, action) => {
			state.size = action.payload;
		},
	}
});

export const { setTransparent, setOpaque, setSmoke, setOpen, setSize } = navSlice.actions;

export default navSlice.reducer;